// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ffe80104","952":"29f844ae"}[chunkId] + ".chunk.js";
};